import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import PersonalizePicker from "../components/PersonalizePicker";
import { useAuth } from "../context/AuthContext";

// Shown right after Register Step 1, or from Profile if a user never picked.
export default function Personalize() {
  const nav = useNavigate();
  const { user, loading, personalize } = useAuth();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && !user) nav("/login");
    // If the user already personalized, send them to their dashboard.
    if (!loading && user?.personalized) nav("/dashboard");
  }, [loading, user, nav]);

  const submit = async ({ lucky_number, avatar_id }) => {
    setBusy(true);
    try {
      await personalize(lucky_number, avatar_id);
      toast.success("All set — welcome aboard 🎉");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save selection");
    } finally { setBusy(false); }
  };

  if (loading || !user) {
    return <div className="p-10 text-center text-slate-500">Loading…</div>;
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="personalize-page">
      {/* progress hint */}
      <div className="mb-4 flex items-center justify-between gap-3 text-xs font-semibold text-slate-500">
        <span>Step 2 of 2</span>
        <div className="flex-1 grid grid-cols-2 gap-2 max-w-[220px]">
          <span className="h-1.5 rounded-full bg-emerald-600"/>
          <span className="h-1.5 rounded-full bg-emerald-400"/>
        </div>
      </div>
      <PersonalizePicker busy={busy} onSubmit={submit}/>
    </div>
  );
}
